import axios from "axios";
import handleError from "./error_handler";
console.log("VITE_API_SERVER", import.meta.env.VITE_API_SERVER);

// TODO: Move these constants to a config file or environment variables
const PROJECT_ID = import.meta.env.VITE_APP_PROJECT_ID || 'cinemagination-1';
const REGION = 'us-central1';

// Determine Base URL
let baseURL = `https://${REGION}-${PROJECT_ID}.cloudfunctions.net`;

if (import.meta.env.DEV) {
  // Local Emulator
  baseURL = `http://127.0.0.1:5001/${PROJECT_ID}/${REGION}`;
}

const axiosClient = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosClient.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const err = handleError(error)
    return Promise.reject(err);
  },
);

export default axiosClient;
